module.exports = __webpack_public_path__ + "static/media/Alert-Regions-Footmap-Left.7f662737.png";